module.exports = __webpack_public_path__ + "static/media/is.b2b4771c.svg";